export const esp = {
    pokedexDescription: 'es',
    bigTitleOne: 'Busca cualquier pokemon',
    firstCardDescription: 'Busca cualquier Pokemon que desee y conozca sus datos, habilidades, tipos y sus hábitos',
    bigTitleTwo: 'Puedes ver todos los pokemon registrados en la pokedex desde el numero uno hasta el ultimo',
    thirdCardDescription: 'Juega minijuegos sobre datos interesantes sobre cada Pokémon y perfecciona tus conocimientos sobre todas estas fantásticas criaturas.',
    
    //navbar
    Home: "Inicio",
    Contact: "Contacto",
    Games: "Juegos",
    lenguage: 'ES',
    pokemonDay: "Pokemon destacado del día",
    score: "Puntaje",
    selectGameMode: "Seleccione el modo de juego",
    warmUp: 'Calentamiento',
    arcade: "Arcade",
    descriptionWarmUp: "Modo de juego relajado para practicar tus habilidades, con un máximo de 10 preguntas.",
    descriptionArcade: "Preguntas ilimitadas, la verdadera prueba de tus conocimientos sobre Pokémon.",
    selectButton: "seleccione",
    //detail pokemon
    numDex: "№ Nacional",
    typesPkmn: "Tipos",
    Species: "Especies",
    Weight: "Peso",
    Height: "altura",
    Abilities: "Habilidades",
    Weak: "Debilidades",
    Resistant: "Resistecnias",
    Immunities: "Inmunidades",
    BaseStats: "Estadisticas base",
    hp: "PS",
    attack: "Ataque",
    defense: "Defensa",
    specialAttack: "Ataque-Especial",
    specialDefense: "Defensa-Especial",
    speed: "velocidad",
    EvolutionChart: "Linea Evolutiva",
    PokedexEntries: "Entradas Pokedex",
    none: "ninguno",
    bug: "bicho",
    dark: "siniestro",
    dragon: "dragon",
    electric: "electrico",
    fairy: "hada",
    fighting: "lucha",
    fire: "fuego",
    flying: "volador",
    ghost: "fantasma",
    grass: "planta",
    ground: "tierra",
    ice: "hielo",
    normal: "normal",
    poison: "veneno",
    psychic: "psiquico",
    rock: "roca",
    steel: "acero",
    water: "agua",

    footerMsg: "Este sitio es sólo para fines educativos y no tiene fines de lucro.",
}